









import { defineComponent, ref } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import { $t } from "@/lib/i18nHelpers";
import { FormFields, FormValues } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseForm from "@/components/BaseForm";
import BasePage from "@/components/BasePage";
import PageTitle from "@/components/PageTitle";

export default defineComponent({
  name: "EmailNotificationsView",
  components: { BasePage, PageTitle, BaseForm, BaseButton },
  props: {
    loading: { type: Boolean, required: true },
    value: { type: Object as () => FormValues, required: true },
  },
  setup(_, { emit }) {
    const { isCreator } = useAuthUser();

    const saving = ref(false);
    const fields: FormFields = [
      {
        class: "__going-live",
        name: "goingLive",
        label: $t("Going live"),
        type: "switch",
      },
    ];
    if (!isCreator.value) {
      fields.push(
        {
          class: "__incoming-messages",
          name: "incomingMessages",
          label: $t("Incoming messages"),
          type: "switch",
        },
        {
          class: "__new-post",
          name: "newPosts",
          label: $t("New posts"),
          type: "switch",
        }
      );
    }

    const onSave = () => {
      saving.value = true;
      emit("submit", () => (saving.value = false));
    };

    return { saving, fields, onSave };
  },
});
